import { IconFont } from '@/components/IconFont'
import NewMember from '@/pages/Organizations/Item/Members/NewMember'
import {
  getOrganizationMembers,
  resetMemberPassword
} from '@/services/member/member'
import { ACCOUNT_TYPES } from '@/utils/constants'
import { useRequest } from 'ahooks'
import { Button, Modal, Table } from 'antd'
import { ColumnFilterItem } from 'antd/es/table/interface'
import copy from 'copy-to-clipboard'
import React, { memo, useContext } from 'react'
import { OrganizationContext } from '../..'
import { MemberTable } from '../MemberTable/MemberTable'

const { Column } = Table

export const roleFilters: ColumnFilterItem[] = Object.keys(ACCOUNT_TYPES).map((key) => ({
  text: ACCOUNT_TYPES[key].toUpperCase(),
  value: key
}))

export const verifyFilters: ColumnFilterItem[] = [
  { text: 'Varified', value: true },
  { text: 'Not Varified', value: false }
]

export const activeFilters: ColumnFilterItem[] = [
  { text: 'Active', value: true },
  { text: 'Inactive', value: false }
]

export default memo(function OrganizationMembers() {
  const orgData = useContext(OrganizationContext).orgData!
  const { data: members = [], refresh, loading } = useRequest(() => getOrganizationMembers(orgData.id, 'MANGED_MEMBER'))

  return <MemberTable
    reload={refresh}
    loading={loading}
    data={members || []} org={orgData} actions={
      <NewMember
        trigger={
          <Button className={'mr-1'} type={'primary'} icon={<IconFont type='icon-add' />}>
            Add Managed Member
          </Button>
        }
        onSuccess={() => {
          refresh()
        }}
      />
  } />

})
